import React, { useEffect, useState } from "react";
import CoreModal from "../../core/layouts/CoreModal";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  API_METHOD_PUT,
  USER_EXCEL_CONFIG_NAME,
  USER_EXCEL_MASTER_COLS,
} from "../../config/constants";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreCustomTab from "../../core/layouts/CoreCustomTab";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreButton from "../../core/inputs/CoreButton";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import {
  api_request,
  downloadTemplate,
  setCommonReducer,
} from "../../store/actions/commonAction";
import {
  ADD_LEDGER_HEAD_ERROR,
  ADD_LEDGER_HEAD_SUCCESS,
  DELETE_LEDGER_HEAD_ERROR,
  DELETE_LEDGER_HEAD_SUCCESS,
  GET_LEDGER_HEAD_ERROR,
  GET_LEDGER_HEAD_SUCCESS,
  USER_SETTINGS_ERROR,
  USER_SETTINGS_SUCCESS,
  USER_SETTINGS_UPDATE_ERROR,
  USER_SETTINGS_UPDATE_SUCCESS,
} from "../../store/types/commonTypes";
import CoreInput from "../../core/inputs/CoreInput";
import CoreTypographySubtitle2 from "../../core/dataDisplay/CoreTypographySubtitle2";

export default function SettingsManagement({ open, setModal }) {
  const dispatch = useDispatch();
  const appSettings = useSelector((state) => state.common.appSettings);
  const userSettings = useSelector((state) => state.common.userSettings);
  const updateSuccess = useSelector(
    (state) => state.common.userSettingUpdateSuccess,
  );
  const updateError = useSelector(
    (state) => state.common.userSettingUpdateError,
  );
  const addLedgerSuccess = useSelector(
    (state) => state.common.addLedgerSuccess,
  );
  const addLedgerError = useSelector((state) => state.common.addLedgerError);
  const deleteLedgerSuccess = useSelector(
    (state) => state.common.deleteLedgerSuccess,
  );
  const deleteLedgerError = useSelector(
    (state) => state.common.deleteLedgerError,
  );
  const ledgerHeads = useSelector((state) => state.common.ledgerHeads);

  const [columns, setColumns] = useState([]);
  const [userConfig, setUserConfig] = useState(null);
  const [ledger, setLedger] = useState("");
  const [ledgerUploadType, setValue] = useState("excel");
  const [file, setFile] = useState(null);

  useEffect(() => {
    let temp = userSettings?.find(
      (set) => set.name === USER_EXCEL_CONFIG_NAME,
    )?.value;
    let tempCols =
      appSettings?.find((sett) => sett.name === USER_EXCEL_MASTER_COLS)
        ?.value || [];

    if (temp) {
      setUserConfig({ ...temp });
      let newCols = tempCols?.map((tempCol) => {
        return { ...tempCol, order: temp[tempCol.name]?.order };
      });
      newCols = sortColumns(newCols);
      setColumns(newCols);
    } else {
      let tempSet = {};
      for (let i = 0; i < tempCols?.length; i++) {
        tempSet[tempCols[i].name] = { active: true, order: tempCols[i].order };
      }
      tempCols = sortColumns(tempCols);

      setUserConfig(tempSet);
      setColumns(tempCols);
    }
  }, [userSettings, appSettings]);

  useEffect(() => {
    if (updateSuccess) {
      setModal(false);
      getUserConfiguration();
      alert("User configuration updated");
      dispatch(
        setCommonReducer({
          userSettingUpdateSuccess: false,
          userSettingUpdateError: false,
        }),
      );
    }
    if (updateError) {
      alert("User configuration update error");
      dispatch(
        setCommonReducer({
          userSettingUpdateSuccess: false,
          userSettingUpdateError: false,
        }),
      );
    }
  }, [updateSuccess, updateError]);

  useEffect(() => {
    if (addLedgerSuccess) {
      getLedgerHeads();
      setLedger("");
      dispatch(
        setCommonReducer({
          addLedgerSuccess: false,
          addLedgerError: false,
        }),
      );
    }
    if (addLedgerError) {
      alert("Ledger head add error");
      dispatch(
        setCommonReducer({
          addLedgerSuccess: false,
          addLedgerError: false,
        }),
      );
    }
    if (deleteLedgerSuccess) {
      getLedgerHeads();
      setLedger("");
      dispatch(
        setCommonReducer({
          deleteLedgerSuccess: false,
          addLedgerError: false,
        }),
      );
    }
    if (deleteLedgerError) {
      alert("Ledger head delete error");
      dispatch(
        setCommonReducer({
          deleteLedgerSuccess: false,
          deleteLedgerError: false,
        }),
      );
    }
  }, [
    addLedgerSuccess,
    addLedgerError,
    deleteLedgerSuccess,
    deleteLedgerError,
  ]);

  useEffect(() => {
    let requestBody = { file: file };
    if (file)
      dispatch(
        api_request(
          API_METHOD_POST,
          "/ledger/head/upload",
          requestBody,
          {},
          null,
          ADD_LEDGER_HEAD_SUCCESS,
          ADD_LEDGER_HEAD_ERROR,
          true,
          true,
        ),
      );
  }, [file]);
  const handleSave = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/userSettings",
        {
          name: USER_EXCEL_CONFIG_NAME,
          value: userConfig,
        },
        {},
        null,
        USER_SETTINGS_UPDATE_SUCCESS,
        USER_SETTINGS_UPDATE_ERROR,
        true,
        false,
      ),
    );
  };

  const onUp = (curCol) => {
    let tempColumns = [...columns];
    tempColumns = sortColumns(tempColumns);

    let headOrder = curCol.order;
    let prevHeadOrder = headOrder - 1;
    let headIndex = tempColumns?.findIndex((col) => curCol.name === col.name);
    if (headIndex > 0) {
      console.log("HEADIND", headIndex);

      let prevHeadIndex = headIndex - 1;
      let prevCol = tempColumns[prevHeadIndex];
      tempColumns[headIndex] = {
        ...tempColumns[headIndex],
        order: prevHeadOrder,
      };
      tempColumns[prevHeadIndex] = {
        ...tempColumns[prevHeadIndex],
        order: headOrder,
      };

      let tempSet = { ...userConfig };
      tempSet[curCol.name] = {
        ...tempSet[curCol.name],
        order: prevHeadOrder,
      };
      tempSet[prevCol.name] = {
        ...tempSet[prevCol.name],
        order: headOrder,
      };
      tempColumns = sortColumns(tempColumns);

      setUserConfig(tempSet);
      setColumns(tempColumns);
    }
  };

  const onDown = (curCol) => {
    let tempColumns = [...columns];
    tempColumns = sortColumns(tempColumns);
    let headOrder = curCol.order;
    let nextHeadOrder = headOrder + 1;
    let headIndex = tempColumns?.findIndex((col) => curCol.name === col.name);
    if (headIndex < tempColumns.length - 1) {
      console.log("HEADIND", headIndex);

      let nextHeadIndex = headIndex + 1;
      let nextCol = tempColumns[nextHeadIndex];

      tempColumns[headIndex] = {
        ...tempColumns[headIndex],
        order: nextHeadOrder,
      };
      tempColumns[nextHeadIndex] = {
        ...tempColumns[nextHeadIndex],
        order: headOrder,
      };
      let tempSet = { ...userConfig };
      tempSet[curCol.name] = {
        ...tempSet[curCol.name],
        order: nextHeadOrder,
      };
      tempSet[nextCol.name] = {
        ...tempSet[nextCol.name],
        order: headOrder,
      };
      tempColumns = sortColumns(tempColumns);
      setUserConfig(tempSet);
      setColumns(tempColumns);
    }
  };

  const handleCheckChange = (event) => {
    if (userConfig) {
      let temp = { ...userConfig };
      temp[event.target.id] = {
        ...temp[event.target.id],
        active: event.target.checked,
      };
      setUserConfig(temp);
    }
  };

  const getUserConfiguration = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/userSettings",
        {},
        {},
        null,
        USER_SETTINGS_SUCCESS,
        USER_SETTINGS_ERROR,
        true,
        false,
      ),
    );
  };

  const addLedgerHead = () => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/ledger/head",
        { name: ledger, label: ledger },
        {},
        null,
        ADD_LEDGER_HEAD_SUCCESS,
        ADD_LEDGER_HEAD_ERROR,
        true,
        false,
      ),
    );
  };

  const getLedgerHeads = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/business/all/LedgerHeads",
        {},
        {},
        null,
        GET_LEDGER_HEAD_SUCCESS,
        GET_LEDGER_HEAD_ERROR,
        true,
        false,
      ),
    );
  };

  const onDeleteLedger = (id) => {
    dispatch(
      api_request(
        API_METHOD_PUT,
        "/ledger/head/" + id + "/delete",
        {},
        {},
        null,
        DELETE_LEDGER_HEAD_SUCCESS,
        DELETE_LEDGER_HEAD_ERROR,
        true,
        false,
      ),
    );
  };

  const sortColumns = (data) => {
    let tempData = [...data];
    tempData?.sort((a, b) => {
      if (a.order > b.order) {
        return 1;
      } else {
        return -1;
      }
    });

    return tempData;
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const downloadExcel = () => {
    dispatch(downloadTemplate());
  };

  console.log("COLUMNS", userConfig, columns);

  return (
    <CoreModal
      title="Configure"
      open={open}
      handleClose={() => {
        setModal(false);
      }}
    >
      <CoreCustomTab
        tabs={[
          {
            head: "Excel Columns",
            body: (
              <Box
                style={{ minHeight: 400, maxHeight: 400, overflowY: "auto" }}
              >
                <Box
                  style={{
                    minHeight: 330,
                    maxHeight: 330,
                    overflowY: "auto",
                  }}
                >
                  <FormGroup>
                    {columns?.map((col) => (
                      <Box
                        key={col.name}
                        style={{
                          display: "flex",
                        }}
                      >
                        <CoreIconButton
                          size="small"
                          onClick={() => {
                            onUp(col);
                          }}
                        >
                          <Icon style={{ fontSize: 14 }}>arrow_upward</Icon>
                        </CoreIconButton>
                        <CoreIconButton
                          size="small"
                          onClick={() => {
                            onDown(col);
                          }}
                        >
                          <Icon style={{ fontSize: 14 }}>arrow_downward</Icon>
                        </CoreIconButton>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleCheckChange}
                              id={col.name}
                              checked={
                                userConfig && userConfig[col.name]
                                  ? userConfig[col.name].active
                                  : false
                              }
                            />
                          }
                          label={col.label}
                        />
                      </Box>
                    ))}
                  </FormGroup>
                </Box>
                <CoreButtonContainer>
                  <CoreButton onClick={handleSave}>Save</CoreButton>
                </CoreButtonContainer>
              </Box>
            ),
          },
          {
            head: "Ledger Heads",
            body: (
              <Box
                style={{ minHeight: 400, maxHeight: 400, overflowY: "auto" }}
              >
                <FormControl>
                  <RadioGroup
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                    }}
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={ledgerUploadType}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="excel"
                      control={<Radio />}
                      label="Upload Excel"
                    />
                    <FormControlLabel
                      value="single"
                      control={<Radio />}
                      label="Single"
                    />
                  </RadioGroup>
                </FormControl>
                <Box
                  style={{
                    // marginTop: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {ledgerUploadType === "single" ? (
                    <>
                      <CoreInput
                        fullWidth={false}
                        label="Ledger Head"
                        value={ledger}
                        onChange={(event) => {
                          setLedger(event.target.value);
                        }}
                      />
                      <CoreButton onClick={addLedgerHead} icon="add">
                        Add
                      </CoreButton>
                    </>
                  ) : (
                    <>
                      <CoreInput
                        type="file"
                        // value={file}
                        onChange={(e) => {
                          setFile(e.target.files[0]);
                        }}
                        inputProps={{
                          "aria-label": "Upload Excel",
                          accept: "application/excel",
                        }}
                      />
                      <CoreIconButton onClick={downloadExcel}>
                        <Tooltip title="Download template">
                          <Icon>download</Icon>
                        </Tooltip>
                      </CoreIconButton>
                    </>
                  )}
                </Box>
                <CoreTypographySubtitle2>
                  Available ledger heads
                </CoreTypographySubtitle2>
                <Box
                  style={{ minHeight: 210, maxHeight: 210, overflowY: "auto" }}
                >
                  {ledgerHeads?.map((col) => (
                    <Grid container>
                      <Grid xs={9} sm={10} item>
                        <CoreTypographyBody1 key={col.name}>
                          {col.label}
                        </CoreTypographyBody1>
                      </Grid>
                      <Grid xs={3} sm={2}>
                        <CoreIconButton
                          onClick={() => {
                            onDeleteLedger(col.id);
                          }}
                        >
                          <Icon>delete</Icon>
                        </CoreIconButton>
                      </Grid>
                    </Grid>
                  ))}
                </Box>
                <CoreButtonContainer>
                  <CoreButton
                    onClick={() => {
                      setModal(false);
                    }}
                  >
                    Close
                  </CoreButton>
                </CoreButtonContainer>
              </Box>
            ),
          },
        ]}
      />
    </CoreModal>
  );
}
